export const FETCH_PROFILECOUNTRY_ACTION = "FETCH_PROFILECOUNTRY_ACTION";
export const FETCH_PROFILECOUNTRY_FAIL_ACTION =
  FETCH_PROFILECOUNTRY_ACTION + "_ERROR";
export const FETCH_PROFILECOUNTRY_SUCCESS_ACTION =
  FETCH_PROFILECOUNTRY_ACTION + "_SUCCESS";

export const FETCH_REGION_ACTION = "FETCH_REGION_ACTION";
export const FETCH_REGION_FAIL_ACTION = FETCH_REGION_ACTION + "_ERROR";
export const FETCH_REGION_SUCCESS_ACTION = FETCH_REGION_ACTION + "_SUCCESS";

export const FETCH_LOCATION_ACTION = "FETCH_LOCATION_ACTION";
export const FETCH_LOCATION_FAIL_ACTION = FETCH_LOCATION_ACTION + "_ERROR";
export const FETCH_LOCATION_SUCCESS_ACTION = FETCH_LOCATION_ACTION + "_SUCCESS";

export const ADD_SHIPPERPROFILE_ACTION = "ADD_SHIPPERPROFILE_ACTION";
export const ADD_SHIPPERPROFILE_FAIL_ACTION =
  ADD_SHIPPERPROFILE_ACTION + "_ERROR";
export const ADD_SHIPPERPROFILE_SUCCESS_ACTION =
  ADD_SHIPPERPROFILE_ACTION + "_SUCCESS";

export const ADD_SHIPPER_IMG_INIT_ACTION = "ADD_SHIPPER_IMG_INIT_ACTION";
export const ADD_SHIPPER_IMG_INIT_ACTION_SUCCESS_ACTION =
  ADD_SHIPPER_IMG_INIT_ACTION + "_SUCCESS";
export const ADD_SHIPPER_IMG_INIT_FAIL_ACTION =
  ADD_SHIPPER_IMG_INIT_ACTION + "_ERROR";
